/* eslint-disable */
import { React } from "react";
import { connect } from "react-redux";
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import Footer from "components/footer/Footer";
import ToggleCollapse from "./components/ToggleCollapse";
import ApplicationName from "components/app-name";

const Sidebar = ({ routes, open, onClose, isCollapse }) => {
  return (
    <div
      className={`sidebar-container sm:none duration-175 linear ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>
      <div className="px-5 py-2 mb-2 backdrop-blur-xl dark:!bg-purple-100/90">
        <ApplicationName extra="flex flex-row items-center mx-auto max-w-[200px]" logoClass="logo-xs" logoOnly={isCollapse}/>
      </div>

      {/* <div className="mb-7 h-px bg-gray-300 dark:bg-white/30 relative hidden xl:flex">
        <ToggleCollapse />
      </div> */}

      {/* Nav item */}
      <ul className="sidebar-menu mb-auto pt-1 w-[255px] max-h-[80vh] overflow-y-auto">
        <Links routes={routes.filter(route => route.isMainMenu)} />
      </ul>

      <Footer />
      {/* Nav item end */}
    </div>
  );
};

const mapStateToProps = (state) => ({
	isCollapse: state.layout.isSideMenuCollapse,
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
